function AppWindow({ app, isActive, shiftX, shiftY, zIndex, onFocus, onClose, onPreviewSite, onPreviewVideo }) {
  return (
    <article
      className={`desktop-window accent-${app.accent} ${isActive ? 'is-active' : 'is-dimmed'}`}
      style={{
        '--window-shift-x': `${shiftX}px`,
        '--window-shift-y': `${shiftY}px`,
        zIndex,
      }}
      onMouseDown={onFocus}
    >
      <header className="window-titlebar">
        <div>
          <p className="window-shell-label">{app.shellLabel}</p>
          <h2>{app.windowTitle}</h2>
        </div>
        <button
          type="button"
          className="window-close"
          onClick={onClose}
          aria-label={`Close ${app.windowTitle}`}
        >
          x
        </button>
      </header>

      <div className="window-content">
        <div className="window-meta">
          <span>{app.category}</span>
          <span>{app.summary}</span>
        </div>

        {app.iframeSrc && (
          <button
            type="button"
            className="preview-site-btn"
            onClick={() => onPreviewSite(app.iframeSrc)}
          >
            Preview Live Website
          </button>
        )}

        {app.videoSrc && (
          <button
            type="button"
            className="preview-site-btn"
            onClick={() => onPreviewVideo(app.videoSrc)}
          >
            Preview Trailer
          </button>
        )}

        {app.socialLinks && (
          <div className="social-links">
            {app.socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-link-btn"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}

        {app.resumeFile && (
          <div className="resume-actions">
            <a
              href={app.resumeFile}
              download="Erickendy Jean Pierre Resume 2026.pdf"
              className="resume-btn download"
            >
              Download Resume
            </a>
            <a
              href={app.resumeFile}
              target="_blank"
              rel="noopener noreferrer"
              className="resume-btn view"
            >
              View Resume
            </a>
          </div>
        )}

        <div className="content-grid">
          {app.cards.map((card) => (
            <section key={card.heading} className="content-card panel-glass">
              <h3>{card.heading}</h3>
              <p>{card.body}</p>
            </section>
          ))}
        </div>

        <section className="detail-panel panel-glass">
          <h3>Quick Notes</h3>
          <ul>
            {app.details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
        </section>
      </div>
    </article>
  );
}

export default AppWindow;
